module.exports = __webpack_public_path__ + "static/media/light-query-rules.206ddb7e.svg";